import {baseApi} from "@/api/base";
import {personalServer} from "@/server/personal";

export class personalInfo extends baseApi{
	router="/personal";
	method="get";

	conversion(response){
		return new personalServer(response);
	}
}


export class personalPwd extends baseApi{
	router='/personal/password';
	method="post";
}


// WEBPACK FOOTER //
// ./src/api/personal.js